module.exports = __webpack_public_path__ + "static/media/icon_Carrier_Ship.7a275be3.svg";